<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="credit-card"/>
          {{ $t('creditTransaction') }}
        </h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="alert alert-warning" v-if="rangeType">{{ $t('olderDataNotice') }}</div>
        <b-tabs class="c-tabs-button" v-model="rangeType" @input="changeRange">
          <b-tab :title="$t('last6Months')"></b-tab>
          <b-tab :title="$t('older')"></b-tab>
        </b-tabs>
        <div class="tile">
          <div class="form-inline">
            <client-select class="mr-1 mb-2" :model="filterFormModel" attribute="client" @change="search" status="all"
                           :isFilter="true" :place-holder="$t('selectClient')"></client-select>
            <form-select class="mr-1 mb-2" :model="filterFormModel" attribute="option" :options="transactionOptions"
                         @change="search"></form-select>
            <form-select class="mr-1 mb-2" :model="filterFormModel" attribute="type" :options="transactionTypes"
                         @change="search"></form-select>
            <form-input v-if="!rangeType" class="mr-1 mb-2" :model="filterFormModel" attribute="keyword"
                        v-on:keydown.enter="search" :placeholder="$t('keyword')"></form-input>
            <time-range-picker :model="filterFormModel" :label="$t('time')" class="mr-1 mb-2" :defaultShortcut="2"
                               ref="timeRangePicker"></time-range-picker>
            <button @click="search" class="btn btn-primary mr-1 mb-2">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-2">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-sorting"
             v-if="['admin', 'owner', 'account', 'operationsManager', 'accountant', 'tech'].includes($store.state.user.role)">
          <div class="row">
            <div class="col-lg-12 c-sorting__right">
              <div class="c-sorting__btn">
                <button v-if="!rangeType" @click="create" class="btn btn-sm btn-success">
                  <font-awesome-icon icon="plus"/>&nbsp;{{ $t('create') }}
                </button>
                <credit-transaction-export v-if="!rangeType" :filter="filterFormModel"
                                           :total-count="itemCount"></credit-transaction-export>
                <lake-credit-transaction-export v-else :filter="filterFormModel"></lake-credit-transaction-export>
              </div>
            </div>
          </div>
        </div>
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [!itemCount ? '' : new Intl.NumberFormat().format(itemCount)]) }}
          </div>
          <div class="c-paging__right" v-if="rangeType">
            <ul class="pagination pagination pagination-sm justify-content-center b-pagination pagination-sm">
              <li class="page-item" v-if="filterFormModel.page > 1">
                <button @click="backPage" class="page-link">‹‹ {{ $t('backToPageOne') }}</button>
              </li>
              <li v-if="filterFormModel.page" class="page-item disabled">
                <span class="page-link">{{ filterFormModel.page }}</span>
              </li>
              <li class="page-item" v-if="nextToken">
                <button @click="nextPage" class="page-link">› {{ $t('nextPage') }}</button>
              </li>
            </ul>
          </div>
          <div class="c-paging__right" v-else>
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center" v-if="!filterFormModel.client">
        <h5>Chọn khách để xem lịch sử giao dịch</h5>
      </div>
      <div class="col-12" v-else-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-lg-2">{{ $t('client') }}</div>
            <div class="col-lg-1">{{ $t('amount') }}</div>
            <div class="col-lg-2">{{ $t('afterBalance') }}</div>
            <div class="col-lg-3">{{ $t('info') }}</div>
            <div class="col-lg-2">{{ $t('time') }}</div>
            <div class="col-lg-2"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('client') }}: </b>
              <span>{{ item.client.companyName }}</span>
            </div>
            <div class="col-lg-1">
              <b class="c-smart-table__label">{{ $t('amount') }}: </b>
              <span :class="item.amount < 0 ? 'text-danger':'text-success'">
                                {{ item.amount | numFormat }} {{ item.client.country.currency }}
                            </span>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('afterBalance') }}: </b>
              <span :class="item.beforeBalance + item.amount <= 0 ? 'text-danger':'text-success'">
                            {{ item.beforeBalance + item.amount | numFormat }} {{ item.client.country.currency }}
                        </span>
            </div>
            <div class="col-lg-3">
              <span><b>{{ $t('content') }}:</b> {{ item.content }}</span>
              <span><b>{{ $t('ref') }}:</b> {{ item.ref }}</span>
              <span><b>{{ $t('type') }}:</b> {{ $t(item.type) }}</span>
            </div>
            <div class="col-lg-2">
              <b class="c-smart-table__label">{{ $t('time') }}: </b>
              <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div class="col-lg-2">
              <div class="c-buttons__col">
                <button v-if="['owner'].includes($store.state.user.role)" type="button"
                        class="btn btn-sm btn-info mr-1" @click="updateCreateTime(item._id)">
                  <font-awesome-icon icon="edit"/>
                  {{ $t('updateCreateTime') }}
                </button>
                <button @click="del(item._id)" type="button" v-if="['owner'].includes($store.state.user.role)"
                        class="btn btn-sm btn-danger mr-1">
                  <font-awesome-icon icon="trash"/>&nbsp;{{ $t('delete') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-else>
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [!itemCount ? '' : new Intl.NumberFormat().format(itemCount)]) }}
          </div>
          <div class="c-paging__right" v-if="rangeType">
            <ul class="pagination pagination pagination-sm justify-content-center b-pagination pagination-sm">
              <li class="page-item" v-if="filterFormModel.page > 1">
                <button @click="backPage" class="page-link">‹‹ {{ $t('backToPageOne') }}</button>
              </li>
              <li v-if="filterFormModel.page" class="page-item disabled">
                <span class="page-link">{{ filterFormModel.page }}</span>
              </li>
              <li class="page-item" v-if="nextToken">
                <button @click="nextPage" class="page-link">› {{ $t('nextPage') }}</button>
              </li>
            </ul>
          </div>
          <div class="c-paging__right" v-else>
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal size="lg" v-model="showForm" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
      <client-select :model="formModel" attribute="client" :errors="formErrors" :label="$t('client')"></client-select>
      <form-select :model="formModel" attribute="option" :options="transactionOptions" :label="$t('transactionOption')"
                   :errors="formErrors"></form-select>
      <form-select :model="formModel" attribute="type" :options="formTypes" :disabled="!formModel.option"
                   :label="$t('transactionType')" :errors="formErrors"></form-select>
      <client-select v-if="formModel.type === 'send'" :model="formModel" attribute="toClient" :errors="formErrors"
                     :label="$t('client')"></client-select>
      <form-input :label="$t('amount')" :model="formModel" attribute="amount" :errors="formErrors"></form-input>
      <form-input :label="$t('content')" :model="formModel" attribute="content" :errors="formErrors"></form-input>
      <form-input v-if="formModel.type !== 'send'" :label="$t('ref')" :model="formModel" attribute="ref"
                  :errors="formErrors"></form-input>
    </b-modal>

    <b-modal v-model="showFormUpdateCreateTime" :title="formTitle" no-close-on-backdrop no-enforce-focus>
      <form-date-time :label="$t('createTime')" :model="formModel" attribute="createTime"
                      :errors="formErrors" format="DD/MM/YYYY HH:mm:ss"></form-date-time>

      <template v-slot:modal-footer>
        <b-button variant="secondary" class="float-right" @click="showFormUpdateCreateTime = false">{{
            $t('cancel')
          }}
        </b-button>
        <b-button variant="primary" class="float-right" @click="saveCreateTime">
          {{ $t('save') }}
        </b-button>
      </template>
    </b-modal>
  </main>
</template>

<script>
import List from '../../mixins/List';
import CRUD from "../../mixins/CRUD";
import ClientSelect from "../../components/ClientSelect";
import TimeRangePicker from "../../components/TimeRangePicker";
import CreditTransactionExport from "./CreditTransactionExport";
import LakeCreditTransactionExport from "./LakeCreditTransactionExport";
import _ from 'lodash';
import moment from "moment";

export default {
  mixins: [List, CRUD],
  components: {CreditTransactionExport, TimeRangePicker, ClientSelect, LakeCreditTransactionExport},
  data() {
    return {
      service: '/credit-transaction',
      autoLoad: false,
      transactionOptions: [
        {value: null, text: this.$t('transactionOption')},
        {value: 'add', text: this.$t('add')},
        {value: 'subtract', text: this.$t('subtract')},
      ],
      transactionTypes: [
        {value: null, text: this.$t('type')},
        {value: 'call', text: this.$t('callFee')},
        {value: 'email', text: 'Email'},
        {value: 'sms', text: 'SMS'},
        {value: 'buyService', text: this.$t('buyService')},
        {value: 'user', text: this.$t('user')},
        {value: 'new', text: this.$t('new')},
        {value: 'newDivide', text: this.$t('newDivide')},
        {value: 'extend', text: this.$t('extend')},
        {value: 'upgrade', text: this.$t('upgrade')},
        {value: 'number', text: this.$t('number')},
        {value: 'brandName', text: this.$t('brandName')},
        {value: 'brandNameRegister', text: this.$t('brandNameRegister')},
        {value: 'setup', text: this.$t('setup')},
        {value: 'deposit', text: this.$t('deposit')},
        {value: 'gift', text: this.$t('gift')},
        {value: 'refund', text: this.$t('refund')},
        {value: 'claim', text: this.$t('claim')},
        {value: 'callRefund', text: this.$t('callRefund')},
        {value: 'smsRefund', text: this.$t('smsRefund')},
        {value: 'send', text: this.$t('send')},
        {value: 'receive', text: this.$t('receive')},
        {value: 'flex', text: 'Flex'},
        {value: 'flexCall', text: this.$t('flexCall')},
        {value: 'flexCustomer', text: this.$t('flexCustomer')},
        {value: 'flexOpportunity', text: this.$t('flexOpportunity')},
        {value: 'flexTicket', text: this.$t('flexTicket')},
        {value: 'flexCallCampaignContact', text: this.$t('flexCallCampaignContact')},
        {value: 'flexEmailCampaignContact', text: this.$t('flexEmailCampaignContact')},
        {value: 'flexSMSCampaignContact', text: this.$t('flexSMSCampaignContact')},
        {value: 'flexZNSCampaignContact', text: this.$t('flexZNSCampaignContact')},
        {value: 'affiliate', text: this.$t('affiliate')},
        {value: 'aiChatbot', text: this.$t('aiChatbot')},
        {value: 'aiAgentToken', text: 'Token AI Agent'},
        {value: 'aiAgentPackage', text: 'Gói AI Token tháng'},
        {value: 'conversationEval', text: 'AI đánh giá hội thoại'},
      ],
      formTypes: [
        {value: null, text: this.$t('chooseOptionFirst')}
      ],
      defaultFormModel: {
        client: null,
        option: null,
        type: null,
        toClient: null
      },
      defaultFilterFormModel: {
        client: null,
        // client: "5e588b99deb1ea31c6ebe0f8",
        type: null,
        option: null,
        keyword: null,
        to: Date.now(),
        from: moment().subtract(6, 'day').startOf('day').valueOf()
      },
      rangeType: 0,
      queryExecutionId: null,
      nextToken: null,
      showFormUpdateCreateTime: false,
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      if (this.filterFormModel.client) {
        this.load();
      }
    }, 200),
    list() {
      this.showList = true;
      this.load();
    },
    changeRange() {
      if (this.rangeType === 0) {
        this.service = '/credit-transaction';
        this.$refs.timeRangePicker.inputVal[0] = moment().subtract('29', 'day').startOf('day');
        this.$refs.timeRangePicker.inputVal[1] = moment(Date.now()).endOf('day');
      } else {
        this.service = '/lake-credit-transaction';
        this.$refs.timeRangePicker.inputVal[0] = null;
        this.$refs.timeRangePicker.inputVal[1] = null;
      }
      this.$refs.timeRangePicker.input();
      if (this.filterFormModel.client) {
        this.filterFormModel.page = 1;
        this.search();
      }
    },

    nextPage() {
      this.filterFormModel.page += 1;
      this.filterFormModel.queryExecutionId = this.queryExecutionId;
      this.filterFormModel.nextToken = this.nextToken;
      this.search();
    },
    backPage() {
      this.filterFormModel.page = 1;
      this.filterFormModel.queryExecutionId = null;
      this.filterFormModel.nextToken = null;
      this.search();
    },
    apply: function (data) {
      this.items = data.docs;
      this.itemCount = data.totalDocs;
      this.queryExecutionId = data.queryExecutionId ? data.queryExecutionId : null;
      this.nextToken = data.nextToken ? data.nextToken : null;
    },
    updateCreateTime: function (id) {
      let loader = this.$loading.show();
      this.$service.get(this.service + '/' + id).then(response => {
        this.formModel = {};
        this.formTitle = this.$t('updateCreateTime');
        this.formErrors = [];
        this.showFormUpdateCreateTime = true;
        this.formModel = response.data;
        this.formModel.id = id;
      }).finally(() => {
        loader.hide();
      });
    },
    saveCreateTime: function (evt) {
      if (evt) {
        evt.preventDefault();
      }
      let loader = this.$loading.show();
      let method = 'put';
      let url = this.service + '/create-time/' + this.formModel.id;
      this.$service({url: url, method: method, data: this.formModel}).then(response => {
        this.showFormUpdateCreateTime = false;
        if (this.load) {
          this.load();
        }
        if (this.reloadBus) {
          this.$bus.$emit(this.reloadBus);
        }
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            text: this.$t('updated'),
            icon: 'success'
          });
        } else {
          this.$swal({
            title: this.$t('error'),
            text: this.$t('updateFailed'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showFormUpdateCreateTime = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
  },
  watch: {
    "formModel.option": {
      handler() {
        if (this.formModel.option) {
          if (this.formModel.option === 'add') {
            this.formTypes = [
              {value: null, text: this.$t('chooseType')},
              {value: 'deposit', text: this.$t('deposit')},
              {value: 'gift', text: this.$t('gift')},
              {value: 'claim', text: this.$t('claim')},
            ];
            this.formModel.type = null;
          } else {
            this.formTypes = [
              {value: null, text: this.$t('chooseType')},
              {value: 'call', text: this.$t('callFee')},
              {value: 'user', text: this.$t('user')},
              {value: 'new', text: this.$t('new')},
              {value: 'extend', text: this.$t('extend')},
              {value: 'upgrade', text: this.$t('upgrade')},
              {value: 'setup', text: this.$t('setup')},
              {value: 'refund', text: this.$t('refund')},
              {value: 'send', text: this.$t('toOtherClient')},
              {value: 'brandName', text: this.$t('brandName')},
              {value: 'brandNameRegister', text: this.$t('brandNameRegister')},
              {value: 'number', text: this.$t('number')},
            ];
            this.formModel.type = null;
          }
        } else {
          this.formTypes = [
            {value: null, text: this.$t('chooseOptionFirst')}
          ];
          this.formModel.type = null
        }
      }, deep: true
    }
  },
  i18n: {
    messages: {
      en: {
        creditTransaction: 'Credit transactions',
        call: 'Call',
        amount: 'Amount',
        content: 'Content',
        time: 'Time',
        ref: 'Ref',
        na: 'N/A',
        afterBalance: 'Credit balance after transaction',
        transactionType: 'Classification',
        add: 'Add',
        subtract: 'Subtract',
        callFee: 'Call fee',
        buyService: 'Buy service',
        user: 'Buy more user',
        new: 'Buy plan (first time)',
        extend: 'Renew plan',
        upgrade: 'Upgrade plan',
        number: 'Phone number subscription fee',
        brandName: 'SMS brand name subscription fee',
        brandNameRegister: 'SMS brand name registration fee',
        setup: 'Phone number setup fee',
        deposit: 'Deposit',
        gift: 'Gift',
        type: 'Type',
        transactionOption: 'Transaction type',
        info: 'Transaction info',
        chooseOptionFirst: 'Choose option first',
        chooseType: 'Choose transaction type',
        refund: 'Refund credit deposit',
        sms: 'SMS fee',
        claim: 'Reimburse',
        send: 'Send fund to other client',
        receive: 'Receive fund from other client',
        newDivide: 'Buy new due to dividing',
        toOtherClient: 'Transfer money to other client',
        flexCall: 'Flex - Call',
        flexCustomer: 'Flex - Customer',
        flexOpportunity: 'Flex - Opportunity',
        flexTicket: 'Flex - Ticket',
        flexCallCampaignContact: 'Flex - Call campaign contact',
        flexEmailCampaignContact: 'Flex - Email campaign contact',
        flexSMSCampaignContact: 'Flex - Sms campaign contact',
        flexZNSCampaignContact: 'Flex - Zns campaign contact',
        olderDataNotice: "Xin lưu ý: Dữ liệu cũ hơn sẽ có thể mất tới 5 phút để truy xuất",
        last6Months: "6 tháng gần nhất",
        older: "Cũ hơn",
        affiliate: "Quà giới thiệu",
        callRefund: "Refund of call charges",
        smsRefund: "SMS refund",
        aiChatbot: "AI agent",
        updateCreateTime: "Update create time",
      },
      vi: {
        creditTransaction: 'Lịch sử giao dịch',
        call: 'Cước gọi',
        amount: 'Số tiền',
        content: 'Nội dung',
        time: 'Thời gian',
        ref: 'Ref',
        na: 'Không có thông tin',
        afterBalance: 'Số dư TK sau GD',
        transactionType: 'Loại giao dịch',
        add: 'Cộng tiền',
        subtract: 'Trừ tiền',
        callFee: 'Cước gọi',
        buyService: 'Mua dịch vụ',
        user: 'Mua thêm người dùng',
        new: 'Mua mới gói dịch vụ',
        extend: 'Gia hạn dịch vụ',
        upgrade: 'Nâng cấp dịch vụ',
        number: 'Phí thuê bao hàng tháng',
        brandName: 'Phí duy trì brand name',
        brandNameRegister: 'Phí đăng ký tên định danh brand name',
        setup: 'Phí khởi tạo số',
        deposit: 'Nạp tiền',
        gift: 'Tặng tiền',
        type: 'Phân loại',
        transactionOption: 'Kiểu giao dịch',
        info: 'Thông tin giao dịch',
        chooseOptionFirst: 'Chọn kiểu giao dịch trước',
        chooseType: 'Chọn loại giao dịch',
        refund: 'Hoàn lệnh nạp tiền',
        sms: 'Phí tin nhắn SMS',
        claim: 'Bồi thường',
        send: 'Chuyển tiền cho client khác',
        receive: 'Nhận tiền từ client khác',
        newDivide: 'Mua mới do tách client',
        toOtherClient: 'Chuyển tiền cho client khác',
        flexCall: 'Flex - Cuộc gọi',
        flexCustomer: 'Flex - Khách hàng',
        flexOpportunity: 'Flex - Cơ hội bán hàng',
        flexTicket: 'Flex - Ticket',
        flexCallCampaignContact: 'Flex - Chiến dịch gọi',
        flexEmailCampaignContact: 'Flex - Chiến dịch email',
        flexSMSCampaignContact: 'Flex - Chiến dịch SMS',
        flexZNSCampaignContact: 'Flex - Chiến dịch ZNS',
        olderDataNotice: "Xin lưu ý: Dữ liệu cũ hơn sẽ có thể mất tới 5 phút để truy xuất",
        last6Months: "6 tháng gần nhất",
        older: "Cũ hơn",
        affiliate: "Quà giới thiệu",
        callRefund: "Hoàn tiền cước gọi",
        smsRefund: "Hoàn tiền SMS",
        aiChatbot: "Nhân viên AI",
        updateCreateTime: "Cập nhật ngày tạo",
      }
    }
  },
}
</script>